<div *ngIf="(canViewOfferCuration && (optionType === 'approval')) ? (optionParentNumber === option.approvalId) : (optionParentNumber === option.offerId)">
  <mat-expansion-panel hideToggle="true" class="option-expansion-panel" [expanded]="true" [disabled]="!(cardExpandable)">
    <mat-expansion-panel-header [collapsedHeight]="'52px'" [expandedHeight]="'52px'" class="option-expansion-header" data-cy="option-panel">
        <div class="section-container" data-cy="option-header">
            <div class="tw-flex-1 tw-self-start tw-self-center">
              <div class="section-container">
                <div class="tw-self-center" *ngIf="cardExpandable">
                  <mat-icon class="expand-icon">{{'keyboard_arrow_down'}}</mat-icon>
                </div>
                <div class="tw-self-center">
                  <span 
                   class="tw-font-bold squished"
                   [ngClass]="{ 'faded' : (optionParentLenderName.length > 45)  }"
                   >{{ optionParentLenderName }}</span>
                  <span class="tw-font-bold">: {{ option.name }}</span><br />
                  <span class="options-header-subtitle">{{ optionParentName }}</span>
                </div>
              </div>
            </div>
            <div class="tw-flex-initial tw-justify-self-end tw-self-center tw-ml-3">
              <div class="preview-container">
                <span class="preview-section tw-gap-2 tw-justify-end" data-cy="option-actions">
                  <span class="tw-font-bold">Status: </span>
                  <span class="status-{{ option.status }}">{{ option.statusLabel }}</span>
                  <offer-option-more-menu
                    [option]="option"
                    [optionType]="optionType"
                    [optionParentName]="optionParentName"
                    (offerOptionUpdated)="handleOfferOptionUpdated($event)"
                  > 
                  </offer-option-more-menu>
                </span>
              </div>
            </div>
          </div>
        </mat-expansion-panel-header>

        <div class="section-container option-values" data-cy="option-values">
            <div class="grid-section option-section-left">
              <div class="option-value-row">
                <div>Amount</div>
                <div class="option-value-column-value tw-font-bold" *ngIf="option.termSet.amount">{{ option.termSet.amount | currency:'USD':'symbol-narrow':'1.0-0' }}</div>
                <div class="option-value-column-value tw-font-bold" *ngIf="!option.termSet.amount">—</div>
              </div>
              <div class="option-value-row">
                <div>Payback</div>
                <div class="option-value-column-value tw-font-bold" *ngIf="option.termSet.payback">{{ option.termSet.payback | currency:'USD':'symbol-narrow':'1.0-0' }}</div>
                <div class="option-value-column-value tw-font-bold" *ngIf="!option.termSet.payback">—</div>
              </div>
              <div class="option-value-row">
                <div>Term</div>
                <div class="option-value-column-value tw-font-bold">{{ option.termSet.term ? (option.termSet.term + '&nbsp;') : '—' }} </div>
                {{ (option.termSet.term | number:'1.0-0') ? termDurationFormatted : '' }}
              </div>
              <div class="option-value-row">
                <div>Payment Amount</div>
                <div class="option-value-column-value tw-font-bold" *ngIf="option.termSet.paymentAmount">{{ option.termSet.paymentAmount | currency:'USD':'symbol-narrow':'1.0-0' }}</div>
                <div class="option-value-column-value tw-font-bold" *ngIf="!option.termSet.paymentAmount">—</div>
              </div>
              <div class="option-value-row">
                <div>Frequency</div>
                <div class="option-value-column-value tw-font-bold">{{ option.termSet.paymentFrequency ? (option.termSet.paymentFrequency | titlecase) : '—' }}</div>
              </div>
              <div class="option-value-row">
                <div># of Payments</div>
                <div class="option-value-column-value tw-font-bold">{{ option.termSet.paymentCount ? (option.termSet.paymentCount | number:'1.0-0') : '—' }}</div>
              </div>
              <div class="option-value-row">
                <div>Factor</div>
                <div class="option-value-column-value tw-font-bold">{{ option.termSet.factorRate ? (option.termSet.factorRate | number:'1.2-2') : '—' }}</div>
              </div>
            </div>

            <div class="grid-section option-section-right">
              <div class="option-value-row">
                <div>Points</div>
                <div class="option-value-column-value tw-font-bold">{{ option.termSet.points ? (option.termSet.points | number:'1.0-0') : '—' }}</div>
              </div>
              <div class="option-value-row">
                <div>Commission</div>
                <div class="option-value-column-value tw-font-bold" *ngIf="option.termSet.commission">{{ option.termSet.commission | currency:'USD':'symbol-narrow':'1.0-0' }}</div>
                <div class="option-value-column-value tw-font-bold" *ngIf="!option.termSet.commission">—</div>
              </div>
              <div class="option-value-row">
                <div>Origination Fee</div>
                <div class="option-value-column-value tw-font-bold">{{ option.termSet.originationFeeAmount ? (option.termSet.originationFeeAmount | currency:'USD':'symbol-narrow':'1.0-0') : '—' }}</div>
              </div>
              <div class="option-value-row">
                <div>Position</div>
                <div class="option-value-column-value tw-font-bold">{{ option.termSet.position ? (option.termSet.position | number:'1.0-0') : '—' }}</div>
              </div>
              <div class="option-value-row">
                <div>Type</div>
                <div class="option-value-column-value tw-font-bold">{{ optionParentType ? (optionParentType | titlecase) : '—' }}</div>
              </div>
              <div class="option-value-row">
                <div>Date Received</div>
                <div class="option-value-column-value  tw-font-bold" *ngIf="optionCreatedFormatted">{{ optionCreatedFormatted | date:'shortDate' }}</div>
                <div class="option-value-column-value  tw-font-bold" *ngIf="!optionCreatedFormatted">—</div>
              </div>
              <div class="option-value-row">
                <div>Expires</div>
                <div class="option-value-column-value  tw-font-bold" *ngIf="parentExpiredFormatted">{{ parentExpiredFormatted | date:'shortDate' }}</div>
                <div class="option-value-column-value  tw-font-bold" *ngIf="!parentExpiredFormatted">—</div>
              </div>
        </div>
    </div>
  </mat-expansion-panel>
</div>
